module.exports = __webpack_public_path__ + "static/media/shareIcon.42aaa8b4.svg";